import BaseAPI from './BaseAPI';
import {AccountStorageAPI} from './AccountStorageAPI';

const TEMPLATE_KEY_PREFIX = 'dashboard_template_';

const generateTemplateKey = () =>
	`${TEMPLATE_KEY_PREFIX}${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;

const storage = new AccountStorageAPI();

export class DashboardAPI extends BaseAPI {

	async create(name) {
		return this.request(`/sec/dashboard`, 'POST', {name});
	}
	async update(dashboard) {
		return this.request(`/sec/dashboard`, 'PUT', {dashboard: dashboard.toJS()});
	}
	async delete(id) {
		return this.request(`/sec/dashboard`, 'DELETE', {id});
	}

	async getPresentationPages() {
		return this.request(`/sec/presentation`, 'GET');
	}
	async savePresentationPage(page) {
		return this.request(`/sec/presentation`, 'POST', page);
	}
	async deletePresentationPage(page) {
		return this.request(`/sec/presentation`, 'DELETE', page);
	}

	async getDashboards(dashboardIds) {
		return this.request(`/sec/dashboard/${JSON.stringify(dashboardIds)}`, 'GET');
	}

	async getTemplates(accountIds) {
		const ids = Array.isArray(accountIds) ? accountIds : [accountIds];
		const results = await Promise.all(ids.map(async (accountId) => {
			try {
				const all = await storage.getAll(accountId);
				return Object.entries(all || {})
					.filter(([key]) => key.startsWith(TEMPLATE_KEY_PREFIX))
					.map(([key, item]) => {
						const data = AccountStorageAPI.decodeContent(item?.content) || {};
						return {
							...data,
							id: key,
							name: item?.name ?? data.name ?? '',
							templateAccountId: accountId,
						};
					});
			} catch (_) {
				return [];
			}
		}));
		return results.flat();
	}
	async saveTemplate(accountId, name, dashboard, existingKey) {
		const key = existingKey && String(existingKey).startsWith(TEMPLATE_KEY_PREFIX)
			? existingKey
			: generateTemplateKey();
		const payload = {...dashboard.toJS(), id: 0, name, templateAccountId: 0};
		return storage.setItem(accountId, key, name, payload);
	}
	async deleteTemplate(accountId, id) {
		return storage.deleteItem(accountId, id);
	}

}
